<template>
    <div class="follow-wrapper">
        <div class="follow-empty">
            功能开发中
        </div>
    </div>
</template>
<script>
export default {
    name:'follow',
    data(){
        return{
        }
    },
    mounted() {
    },
    methods: {},
}
</script>
<style lang="scss" scoped>
    .follow-wrapper{
        position: relative;
        height: 100%;
    }
    .follow-empty{
        padding-top: j(300);
        box-sizing: border-box;
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%,-35%);
        width: j(750);
        height: j(700);
        background: url('/static/images/empty/devoloping.png') no-repeat;
        background-size: cover;
        text-align: center;
        font-size:j(32);
        font-weight:400;
        color:rgba(155,157,169,1);
    }
</style>



// WEBPACK FOOTER //
// src/views/follow/follow.vue